import React, { useState, useEffect } from "react";
import { db, auth } from "../firebaseConfig";
import { doc, updateDoc, getDoc, setDoc } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import ProgressBar from "../components/ProgressBar"; // 追加
import "../styles/CompleteProfile.css";

const CompleteProfile3= () => {
  const [user] = useAuthState(auth);
  const [profile, setProfile] = useState({
    marriage_aim: "",
    skinship: "",
    love_exist: "",
    friendship_marriage: "",
    children_want: "",
    children_have: "",
    marital_status: "",
    cohabiter_aim: "",
});

  const [error, setError] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);
  const navigate = useNavigate();

  const cohabiterAimOptions = [
    { value: '一緒に住みたい', label: '一緒に住みたい' },
    { value: '同居を希望しない', label: '同居を希望しない' },
    { value: '場合による', label: '場合による' },
  ];
  
  const marriageAimOptions = [
    { value: 'あり', label: 'あり' },
    { value: 'なし', label: 'なし' },
    { value: '場合による', label: '場合による' },
  ];
  
  const loveExistOptions = [
    { value: 'ある', label: 'ある' },
    { value: 'ない', label: 'ない' },
    { value: 'わからない', label: 'わからない' },
  ];

  const skinshipOptions = [
    { value: 'NGなし', label: 'NGなし' },
    { value: 'スキンシップはしたくない', label: 'スキンシップはしたくない' },
    { value: 'ハグまで', label: 'ハグまで' },
    { value: '手を繋ぐ', label: '手を繋ぐ' },
    { value: 'その他', label: 'その他' }
  ];
  
  const childrenWantOptions = [
    { value: '欲しい', label: '欲しい' },
    { value: '欲しくない', label: '欲しくない' }
  ];
  
  const childrenHaveOptions = [
    { value: 'いる', label: 'いる' },
    { value: 'いない', label: 'いない' }
  ];
  
  const maritalStatusOptions = [
    { value: '未婚', label: '未婚' },
    { value: '離婚', label: '離婚' },
  ];
  const friendshipMarriageOptions = [
    { value: '希望する', label: '希望する' },
    { value: '希望しない', label: '希望しない' },
    { value: '場合による', label: '場合による' },
  ];
  


  useEffect(() => {
    if (user) {
      user.reload().then(() => {
        setEmailVerified(user.emailVerified);
      });

      const fetchProfile = async () => {
        try {
          const docRef = doc(db, "members", user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            setProfile({
              marriage_aim: data.marriage_aim || "",
              skinship: data.skinship || "",
              love_exist: data.love_exist || "",
              friendship_marriage: data.friendship_marriage || "",
              children_want: data.children_want || "",
              children_have: data.children_have || "",
              marital_status: data.marital_status || "",
              cohabiter_aim: data.cohabiter_aim || "",
          });
          
          }
        } catch (error) {
          console.error("Error fetching profile:", error.message);
          setError("プロフィールの取得中にエラーが発生しました。");
        }
      };
      fetchProfile();
    }
  }, [user]);

  const handleSave = async () => {
    if (!emailVerified) {
      setError("メールアドレスの認証が完了していません。メールを確認してください。");
      return;
    }

    // 8項目を取得
    const { marriage_aim, skinship, love_exist, friendship_marriage, children_want, children_have, marital_status, cohabiter_aim } = profile;

    try {
      const userDocRef = doc(db, "members", user.uid);
      const docSnap = await getDoc(userDocRef);

      const profileData = {
        marriage_aim: marriage_aim || "", 
        skinship: skinship || "",
        love_exist: love_exist || "",
        friendship_marriage: friendship_marriage || "",
        children_want: children_want || "",
        children_have: children_have || "",
        marital_status: marital_status || "",
        cohabiter_aim: cohabiter_aim || "",
      };

      if (docSnap.exists()) {
        await updateDoc(userDocRef, profileData);
      } else {
        await setDoc(userDocRef, profileData);
      }

      navigate("/complete-profile4"); // 次のページへ
    } catch (error) {
      console.error("Error saving profile:", error.message);
      setError("プロフィールの保存中にエラーが発生しました。");
    }
};


  return (
    <div className="complete-profile-container">
      <ProgressBar step={3} totalSteps={6} /> {/* 進捗バーを追加 */}

      <h2>恋愛・結婚について(任意)</h2>
      {error && <p className="error-message">{error}</p>}

      {emailVerified ? (
        <>


<div className="form-group-a">
  <label>結婚に対する意思:</label>
  <Select
    name="marriage_aim"
    isSearchable={false}
    value={profile.marriage_aim ? { value: profile.marriage_aim, label: profile.marriage_aim } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, marriage_aim: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...marriageAimOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>スキンシップ許容度：</label>
  <Select
    name="skinship"
    isSearchable={false}
    value={profile.skinship ? { value: profile.skinship, label: profile.skinship } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, skinship: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...skinshipOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>恋愛感情の有無:</label>
  <Select
    name="love_exist"
    isSearchable={false}
    value={profile.love_exist ? { value: profile.love_exist, label: profile.love_exist } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, love_exist: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...loveExistOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>友情結婚の希望:</label>
  <Select
    name="friendship_marriage"
    isSearchable={false}
    value={profile.friendship_marriage ? { value: profile.friendship_marriage, label: profile.friendship_marriage } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, friendship_marriage: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...friendshipMarriageOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>子供の希望：</label>
  <Select
    name="children_want"
    isSearchable={false}
    value={profile.children_want ? { value: profile.children_want, label: profile.children_want } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, children_want: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...childrenWantOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>子供の有無：</label>
  <Select
    name="children_have"
    isSearchable={false}
    value={profile.children_have ? { value: profile.children_have, label: profile.children_have } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, children_have: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...childrenHaveOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>結婚歴：</label>
  <Select
    name="marital_status"
    isSearchable={false}
    value={profile.marital_status ? { value: profile.marital_status, label: profile.marital_status } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, marital_status: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...maritalStatusOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>同居の希望:</label>
  <Select
    name="cohabiter_aim"
    isSearchable={false}
    value={profile.cohabiter_aim ? { value: profile.cohabiter_aim, label: profile.cohabiter_aim } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, cohabiter_aim: option.value !== "" ? option.value : "" })}
    options={[{ value: "", label: "選択してください" }, ...cohabiterAimOptions]}
    className="select-box"
  />
</div>



          <button onClick={handleSave} className="complete-profile-button">次へ</button>
        </>
      ) : (
        <p></p>
      )}
    </div>
  );
};

export default CompleteProfile3;
